import { useQuery } from "@tanstack/react-query";
import { getShippingCountries } from "../services/shippingService";

const useShippingCountries = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["shippingCountries"],
    queryFn: () => getShippingCountries(),
    select: (response) => response.message || [],
  });

  return {
    countries: data || [],
    loading: isLoading,
    error: error?.message || null,
  };
};

export default useShippingCountries;
